<template>
  <div class="components_warp">
      <div class="top-container">
          <div v-for="(topic, index) in topics" :key="index">
            <div class="ques-item" v-if="index == curIndex">
              <div class="q-title q-min-title">本小题没有时间限制</div>
              <!--<div class="q-title q-min-title">{{question.name}}</div>-->
              <div class="q-art2-answer">
                <ul>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <div
                  class="right-answer" v-bind:style="{background:'rgb('+topic.topic+')'}"></div>
              </div>
              <div class="art2-opt">
                <!-- <div
                  class="art-opt"
                  v-bind:style="{background:'rgb('+topic.options[0].optTxt+')'}"
                  @click="answerClickB(1)"
                ></div>
                <div
                  class="art-opt"
                  v-bind:style="{background:'rgb('+topic.options[1].optTxt+')'}"
                  @click="answerClickB(2)"
                ></div> -->
                <ul>
                  <li v-for="(t,index) in topic.options" :key="index" class="art-opt" v-bind:style="{background:'rgb('+t.optTxt+')'}" @click="answerClickB(t,index)"  :class="activeClass == index ? 'active':''"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_warp">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            startTime:'',
            endTime:'',
            tempTime:'',
            curTempTime:'',
            curIndex: 0,
            topics: [],
            num:'',
            activeClass:-1,
            showMode:false,
            answers:[],
            letterArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
            url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp41'}}
        }
    },
    created() {
    this.getTopicApi();
  },
  mounted(){
    this.startTime = new Date().getTime();
  },
  methods: {
    getTopicApi() {
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.kjnlList3}`,
          {},
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.topics = res.data.data;
          console.log(this.topics);
        });
    },
    answerClickB(item,index){
      this.num = item.optOrder
      this.activeClass = index;
    },
    next() {
      if(this.num == ""){
        this.$message.error('请选择答案')
        return false
      }
      this.curTempTime = new Date().getTime();
      if(this.num == 1){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'A'
        })
      }else if(this.num == 2){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'B'
        })
      }
      this.num = ""
      if (this.curIndex + 1 < this.topics.length) {
        this.activeClass = -1
        this.curIndex++;
         
      } else {
        this.saveNode(2,41,()=>{
          this.submit()
        })
      }
    },
    submit(){ //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.kjnlAdd3}`,{
          testId:sessionStorage.getItem('testId'),
          time:this.tempTime,
          answers:this.answers,
      },{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            var data = res.data;
          if(data.code==2000){
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url:this.url,
              },
            });
          }
        })
    },
  },
}
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}
.top-container{
    margin: 0 auto;
}
.top-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ques-item{
    text-align: center;
    width: 306px;
}
.q-art2-answer{
    overflow: hidden;
    margin-top: 15px;
    position: relative;
}
.q-art2-answer ul li{
    width: 50px;
    height: 50px;
    margin-right: 1px;
    background: #cccccc;
    float: left;
    margin-bottom: 1px;
}
 .art2-opt {
    width: 305px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    margin: 30px auto 0;
}
 .right-answer {
    position: absolute;
    left: 153px;
    top: 102px;
    width: 50px;
    height: 50px;
}
.art-opt {
    width: 50px;
    height: 50px;
    cursor: pointer;
    background: yellow;
}
.art2-opt ul{
  width: 305px;
  display: flex;
  justify-content: space-around;
}

.active {
 /* background: #eee; */
 border:1px solid red;
}
</style>